<script>
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import TwBadge from '@/components/generic/tw-badge.vue'
import { UserGroupIcon } from '@heroicons/vue/24/outline'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'

export default {
  name: "TeamCompact",
  components: { TwBadge, TwProgressBar, UserGroupIcon },
  props: {
    team: {
      type:Object,
      required:true
    }
  },
  computed: {
    fundraiser() {
      return useFundraiserPublicStore().getItemById(this.team.fundraiser_id)
    },
    raisedFormatted() {
      return this.$filters.formatCurrency(this.team.cached?.raised ?? this.team.raised, this.team.currency)
    },
    goalFormatted() {
      return this.$filters.formatCurrency(this.team.goal, this.team.currency)
    }
  }
}
</script>

<template>
  <router-link class="flex gap-3 border-gray-200 border rounded-2xl p-4 hover:bg-white" :to="{name: 'FundraiserTeamPublicPage', params: { fundraiserId: team.fundraiser_id, teamId: team.id }}">
    <span class="inline-flex size-12 items-center justify-center rounded-full bg-gray-100">
      <img v-if="team.logo_url" :src="team.logo_url" :alt="`Team Logo for ${team.name}`" class="rounded-full object-cover">
      <UserGroupIcon v-else class="h-5 w-5" />
    </span>
    <div class="flex flex-col gap-1 grow mt-1">
      <h6>
        {{ team.name }}
      </h6>
      <div class="text-xs text-gray-600">
        <span v-if="team.cached">{{ raisedFormatted }}</span> raised of {{ goalFormatted }} goal
      </div>
      <tw-progress-bar v-if="team.cached" class="mt-3" :progress="team.cached.percentage_raised" />
      <span>
        <tw-badge v-if="team.cached && team.cached.team_name" size="xs" class="my-1 bg-gray-100">
          <UserGroupIcon class="h-4 w-4" /> <router-link v-if="team.belongs_to_team_id" :to="{name: 'FundraiserTeamPublicPage', params: { fundraiserId: team.fundraiser_id, teamId: team.id }}" class="ml-1 font-semibold hover:underline">
            {{ team.cached.team_name }}
          </router-link>
          <span v-else class="font-semibold">
            {{ team.cached.team_name }}
          </span>
        </tw-badge>
      </span>
    </div>
  </router-link>
</template>

<style scoped>

</style>
